module.exports = __webpack_public_path__ + "img/swiper-button.42e6140b.svg";